<div class="app-container">
  @if (isCreating() || queryUserGroup.data()?.id) {
    <form [formGroup]="userGroupForm" (ngSubmit)="isCreating() ? createUserGroup.mutate() : updateUserGroup.mutate()">
      <page-header
        [icon]="'fa-users-cog'"
        [title]="isCreating() ? 'group.new' : 'group.edit'"
        [appendNoTranslationTitlePart]="isCreating() ? '' : queryUserGroup.data() ? queryUserGroup.data().name : ''"
      >
        @if (queryUserGroup.data()) {
          <ng-container class="header-button">
            @if (!isCreating()) {
              <btn
                [btnType]="'submit'"
                [classes]="['btn-first', 'float-right']"
                [label]="'save'"
                [title]="'save' | translate"
                [icon]="'far-check'"
                [isLoading]="loading()"
                [dataCyAttribute]="'update-group'"
              ></btn>
            }
            @if (isCreating()) {
              <btn
                [label]="'save'"
                [title]="'save' | translate"
                [icon]="'far-check'"
                [btnType]="'submit'"
                [classes]="['btn-first', 'float-right']"
                [btnDisabled]="!userGroupForm.value.roles.length || loading()"
                [isLoading]="loading()"
                [dataCyAttribute]="'create-group'"
              ></btn>
            }
            @if (!isCreating()) {
              <btn
                [icon]="'far-trash-alt'"
                [label]="'delete'"
                [title]="'delete' | translate"
                [btnType]="'button'"
                (onEvent)="deleteUserGroup.mutate()"
                [classes]="['btn-first-red', 'float-right', 'me-2']"
                [dataCyAttribute]="'delete-group'"
              ></btn>
            }
          </ng-container>
        }
        <ng-container class="back-button">
          <btn
            [label]="'back'"
            [title]="'back' | translate"
            [isBackButton]="true"
            [classes]="['btn-third', 'float-right', 'me-2']"
            [icon]="'far-arrow-left'"
            (onEvent)="goBack()"
          ></btn>
        </ng-container>
      </page-header>
      <section class="content">
        @if (isCreating() || queryUserGroup.data()?.id > 0) {
          <div class="card">
            <div class="card-body">
              <loading-spinner [isLoading]="loading()" [classesString]="'top-50'"></loading-spinner>
              <div class="row">
                <div class="col-sm-6">
                  <form-row-input
                    [formGroup]="userGroupForm"
                    formControlName="name"
                    [label]="'name'"
                    [icon]="'fa-list'"
                    [dataCyAttribute]="'usergroup-name'"
                  >
                  </form-row-input>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>{{ 'roles' | translate }}:</label>
                    @for (role of queryRoles.data(); track role) {
                      <div>
                        <form-row-checkbox
                          [label]="role.name"
                          [cursorPointer]="true"
                          [model]="userGroupForm.value.roles.includes(role.role)"
                          (modelChange)="updateRole(role.role, $event)"
                        ></form-row-checkbox>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </section>
    </form>
  }
</div>
